/*************************************
 *
 * 用户 store
 *
 *************************************/

import { wechatAuthLogin, wechatAuthLoginLiveTest } from '@/api/v1/groupBuy'
import { saveToken, getToken, saveUserInfo, getUserInfo, saveUnionid, getUnionid } from '../../utils/webCache'

const state = {
  token: getToken(), // 用户token
  userInfo: getUserInfo(), // 用户信息
  unionid: getUnionid()
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_UNIONID: (state, unionid) => {
    state.unionid = unionid
  }
}

const actions = {
  wechatLogin ({ commit }, params) {
    return new Promise((resolve, reject) => {
      wechatAuthLogin(params).then(response => {
        if (response.code === 200) {
          console.log(response)
          commit('SET_USER_INFO', saveUserInfo(response.data.user))
          commit('SET_TOKEN', saveToken(response.data.token))
          if (response.data.unionid) {
            commit('SET_UNIONID', saveUnionid(response.data.unionid))
          }
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   * 用于直播 测试 后期删除 一系列 直播删除相关东西
   *
   * @param commit
   * @param params
   */
  wechatLoginLiveTest ({ commit }, params) {
    return new Promise((resolve, reject) => {
      wechatAuthLoginLiveTest(params).then(response => {
        if (response.code === 200) {
          console.log(response)
          commit('SET_USER_INFO', saveUserInfo(response.data.user))
          commit('SET_TOKEN', saveToken(response.data.token))
          if (response.data.unionid) {
            commit('SET_UNIONID', saveUnionid(response.data.unionid))
          }
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  appLogin ({commit}, params) {
    return new Promise((resolve, reject) => {
      commit('SET_USER_INFO', saveUserInfo(params.data.user))
      commit('SET_TOKEN', saveToken(params.data.token))
      resolve(params)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js